import { Container } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const StyledContainer = styled(Container)`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: ${getPurpurSpacing('300')};
    padding-top: ${getPurpurSpacing('400')};
    padding-bottom: ${getPurpurSpacing('800')};

    ${purpurMedia('md')`
        padding-top: ${getPurpurSpacing('800')};
        padding-bottom: ${getPurpurSpacing('800')};
    `}

    ${purpurMedia('lg')`
        flex-direction: row;
        gap: ${getPurpurSpacing('800')};
        padding-bottom: ${getPurpurSpacing('1200')};
        padding-top: ${getPurpurSpacing('1200')};
    `}
`;

export const MediaContainer = styled.div`
    width: 11.5rem;
    height: 11.5rem;
    order: 1;

    ${purpurMedia('md')`
        width: 15rem;
        height: 15rem;
    `}

    ${purpurMedia('lg')`
        width: 17.5rem;
        height: 17.5rem;
        order: 2;
    `}
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    max-width: none;
    order: 2;
    gap: ${getPurpurSpacing('400')};

    ${purpurMedia('lg')`
        width: auto;
        max-width: 34rem;
        order: 1;
    `}
`;

export const MessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('250')};
`;

export const Paragraph = styled.p`
    margin: 0;
`;

export const ActionsContainer = styled.div`
    display: flex;
    gap: ${getPurpurSpacing('200')};
    flex-direction: column;
    width: 100%;

    ${purpurMedia('md')`
        flex-direction: row;
    `}
`;
